import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';


@Pipe({
	name: 'format'
})
export class DateFormatPipe implements PipeTransform {
	transform(dateString: any, arg?: any) {
		const date = moment(dateString, 'DD/MM/YYYY');
		return date.format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
}
